import { render } from "./HomeCollegiate.vue?vue&type=template&id=6673e0be"
import script from "./HomeCollegiate.vue?vue&type=script&lang=js"
export * from "./HomeCollegiate.vue?vue&type=script&lang=js"

import "./HomeCollegiate.vue?vue&type=style&index=0&id=6673e0be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__